export enum SendContractType {
  reminder = 'reminder',
  signature = 'signature'
}
